<mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayout="column"  fxLayoutAlign="start center">
    <div fxFlex class="filter w-100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
      <mat-form-field class="accent">
        <mat-label>Search all {{ data?.data?.length ?? 0 }} homes</mat-label>
        <input matInput type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="loadData()"
          (keyup.esc)="searchTerm=''; loadData()"
          name="searchTerm"
          placeholder="Search all {{ data?.data?.length ?? 0 }} homes">
        <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadData()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div fxLayout="row" fxLayoutGap="10px">
        <button
          type="submit"
          mat-flat-button color="primary"
          (click)="loadData()"
          matTooltip="Search"
          [class.button-spinner]="loading"
          [disabled]="loading">
          <mat-icon>search</mat-icon> Search
        </button>
        <button mat-flat-button color="accent" (click)="downloadCSV()">
          Export CSV
          <mat-icon>view_list</mat-icon>
        </button>
      </div>
    </div>
    <div class="m-b-20 w-100" fxFlex="100">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <small class="text-info"><i>filter:</i></small>
        <mat-chip-list #optionChipList>
          <mat-chip *ngIf="searchTerm" class="green-chip" color="accent">
            <span>{{searchTerm}}</span>
            <button matChipRemove (click)="searchTerm = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip
            [class.green-chip]="taggedOnly"
            (click)="setTaggedOnly()">
            <span class="m-r-2">Tagged Homes</span>
            <button matChipRemove (click)="setTaggedOnly()">
              <mat-icon *ngIf="!taggedOnly" color="basic" matTooltip="Filter">filter_alt_on</mat-icon>
              <mat-icon *ngIf="taggedOnly" color="basic" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip
            [class.green-chip]="showOnlyVisible === true"
            (click)="toggleVisibility()">
            <span class="m-r-2">Visible Homes</span>
            <button matChipRemove (click)="toggleVisibility()">
              <mat-icon *ngIf="showOnlyVisible === undefined || showOnlyVisible === false" color="basic" matTooltip="Filter">filter_alt_on</mat-icon>
              <mat-icon *ngIf="showOnlyVisible === true" color="basic" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="contrast" *ngFor="let item of data.data"
  [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayout="column">
    <div fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="30" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px">
        <a class="link" [routerLink]="['/homes', item.name]" matTooltip="Open home detail">
          <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | encodeHtml | highlight: searchTerm"></strong>
        </a>
        <small *ngIf="item?.home?.name">{{ item.home.name }}</small>
      </div>
      <div fxFlex fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="4px" fxLayoutGap.lt-sm="18px">
        <mat-chip-list>
          <mat-chip *ngFor="let tag of item?.homeTags" [matTooltip]="getTagCategory(tag?.tagId)">
            {{ getTagLabel(tag?.tagId) }}
          </mat-chip>
        </mat-chip-list>
        <mat-icon
          [color]="isRenderedThisMonth(item.dateLastRendered) ? 'accent' : ''"
          [class.disabled-icon]="!isRenderedThisMonth(item.dateLastRendered)"
          [matTooltip]="item.dateLastRendered ? (isRenderedThisMonth(item.dateLastRendered) ? 'Rendered this month: ' : 'Last rendered: ') + formatDate(item.dateLastRendered) : 'Never rendered'">
          image
        </mat-icon>
        <mat-icon [class.raytraceddraft]="hasRaytraceDraft(item)"
          [class.disabled-icon]="!hasRaytraceDraft(item)"
          [matTooltip]="item.dateLastRaytracedDraftRendered ? 'Last RaytracedDraft render: ' + formatDate(item.dateLastRaytracedDraftRendered) : 'Never RaytracedDraft rendered'">
          panorama
        </mat-icon>
        <mat-icon [class.raytracedplus]="hasRaytracePlus(item)"
          [class.disabled-icon]="!hasRaytracePlus(item)"
          [matTooltip]="item.dateLastRaytracedPlusRendered ? 'Last RaytracedPlus render: ' + formatDate(item.dateLastRaytracedPlusRendered) : 'Never RaytracedPlus rendered'">
          panorama
        </mat-icon>
        <mat-icon class="link" *ngIf="item.isHidden" mat-icon-button color="primary" matTooltip="Hidden - Click to make visible" (click)="toggleHomeVisibility(item); $event.stopPropagation()">visibility_off</mat-icon>
        <mat-icon class="link" *ngIf="!item.isHidden" mat-icon-button color="accent" matTooltip="Visible - Click to hide" (click)="toggleHomeVisibility(item); $event.stopPropagation()">visibility</mat-icon>
      </div>
    </div>
  </mat-card-content>
</mat-card>
